var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReload = function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "evenodd",
    d: "M15.087 3.034a9.7 9.7 0 0 0-3.838-.784C5.868 2.25 1.5 6.617 1.5 12s4.367 9.75 9.75 9.75a9.75 9.75 0 0 0 9.195-6.5.75.75 0 1 0-1.414-.5 8.25 8.25 0 0 1-7.781 5.5V3.75a8.22 8.22 0 0 1 5.954 2.54l.468.544-2.386 2.386a.75.75 0 0 0 .53 1.28H21a.75.75 0 0 0 .75-.75V4.567a.75.75 0 0 0-1.28-.531L18.736 5.77l-.42-.488-.013-.013a9.7 9.7 0 0 0-3.217-2.235m-3.837.716v16.5A8.25 8.25 0 0 1 3 12a8.25 8.25 0 0 1 8.25-8.25",
    clipRule: "evenodd"
  })));
};
export default SvgReload;